import { Column } from 'primereact/column';
import { CustomDataTable, filterApplyTemplate, filterClearTemplate, tableOptions } from '../components/CustomDatatable';
import NotifyController from '../utilities/Toast';
import FeedbackService from '../service/FeedbackService';
import { Image } from 'primereact/image';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from 'primereact/button';
import moment from 'moment';

const Feedback = () => {
    const navigate = useNavigate();
    const { page } = useParams();

    const onOptionChange = async (option: tableOptions) => {
        const feedbacks = await FeedbackService.getInstance().getListFeedback(option.page, option.rowPerPage, 'APP_CHANGECLOTHER').catch((error) => {
            NotifyController.error(error?.message)
            console.log(error);
        })
        return { total: feedbacks.data.totalRecord, data: feedbacks.data.items }
    }

    const bodyAssetUrl = (rowData: any) => {
        return (
            <div className="p-3">
                <Image src={rowData.image_url} alt={rowData.image_url} width="120" preview />
            </div>
        );
    };

    const bodyIsLike = (rowData: any) => {
        return (
            <div className="p-field-icon">
                {rowData.is_like ? (
                    <i className="pi pi-thumbs-up"></i>
                ) : (
                    <i className="pi pi-thumbs-down"></i>
                )}
            </div>
        );
    };

    const bodyFormattedDateTime = (rowData: any) => {
        const timestamp = rowData.created_ts;
        if (!timestamp) return <span></span>;

        // Convert the timestamp using moment and adjust for GMT+7 timezone
        const formattedDateTime = moment(timestamp)
            .utcOffset(7) // Set offset for GMT+7
            .format('YYYY-MM-DD HH:mm:ss'); // Format the date as 'yyyy-MM-dd HH:mm:ss'

        return <span>{formattedDateTime}</span>;
    };

    const handlePageChange = (page: any) => {
        navigate(`/feedback/${page}`)
    };

    const handleDetailButtonClick = async (rowData: any) => {
        try {
            const imageData = await FeedbackService.getInstance().getIdFromUrl(rowData.image_url);
            navigate(`/generated-image/detail/${imageData.data}`);
        } catch (error: any) {
            NotifyController.error(error?.message);
            console.log(error);
        }
    };

    return (
        <div className="grid crud-demo">
            <div className="col-12">
                <div className="card">
                    <h5>Feedback</h5>
                    <CustomDataTable
                        onOptionChange={onOptionChange}
                        page={parseInt(page ?? '1')}
                        handlePageChange={handlePageChange}
                    >
                        <Column
                            body={(rowData: any) => (
                                <Button onClick={() => handleDetailButtonClick(rowData)}>Detail</Button>
                            )}
                            header="Action"
                            headerStyle={{ width: '6rem', textAlign: 'center' }}
                            style={{ textAlign: 'center' }}
                        />
                        <Column field="created_ts" sortable body={bodyFormattedDateTime} header="Created" headerStyle={{ minWidth: '10rem' }} filter filterClear={filterClearTemplate} filterApply={filterApplyTemplate}></Column>
                        <Column field="device_token" header="Device Token" sortable headerStyle={{ minWidth: '10rem' }} filter filterClear={filterClearTemplate} filterApply={filterApplyTemplate}></Column>
                        {/* <Column field="name" header="Name" sortable headerStyle={{ minWidth: '10rem' }} filter filterClear={filterClearTemplate} filterApply={filterApplyTemplate}></Column> */}
                        <Column field="content" header="Content" sortable headerStyle={{ minWidth: '10rem' }} filter filterClear={filterClearTemplate} filterApply={filterApplyTemplate}></Column>
                        {/* <Column field="source" header="Source" sortable headerStyle={{ minWidth: '10rem' }} filter filterClear={filterClearTemplate} filterApply={filterApplyTemplate}></Column> */}
                        <Column field="image_url" body={bodyAssetUrl} header="Asset" headerStyle={{ width: 120 }}></Column>
                        <Column field="is_like" body={bodyIsLike} header="Is Like" headerStyle={{ minWidth: '10rem' }} filter filterClear={filterClearTemplate} filterApply={filterApplyTemplate}></Column>
                        <Column field="type" header="Type" sortable headerStyle={{ minWidth: '10rem' }} filter filterClear={filterClearTemplate} filterApply={filterApplyTemplate}></Column>
                    </CustomDataTable>

                </div>
            </div>
        </div>
    );
};

export default Feedback;
